// eslint-disable-next-line no-unused-vars
import { http, prepareHttpQuery } from 'http';

export default {
  userInfo: () => http.get('/userinfo', { withCredentials: true }),

  getLoginEntraId: ({ user }) =>
    http.get(`/login-url?provider=ids&email=${user}`, { withCredentials: true }),

  getLogout: () => http.get('/logout', { withCredentials: true })
};
